<template>
  <div>
    <!--begin::Content header-->
    
    <!--end::Content header-->
      <!--begin::Form-->
      <b-form class="form-signin d-flex align-items-stretch flex-column" @submit.stop.prevent="onSubmit">
        <div class="text-center mb-2">
          <img class="mb-2" src="media/img/logotipo-inverse.svg" alt="" width="120">
          <h3 class="mb-0">Iniciar Sesión</h3>
        <span>Cambia tu contraseña</span>
        </div>

        <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
       
        <div v-if="step2" class="d-flex align-items-stretch flex-column">
              <div class="alert alert-success messaging">
              <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="exclamation circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-exclamation-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path></g></svg>
              Hemos enviado tu nueva contraseña.
                <p>Ya puedes iniciar sesión. <a href="">Ir al login</a></p>
            </div>
        </div>
        <div v-if="!step2 && errors.length==0" class=" d-flex align-items-stretch flex-column">
         <div class="alert alert-secondary messaging">
            <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="exclamation circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-exclamation-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path></g></svg>
            HOLA, {{client.nombres}}, generaremos una nueva contraseña y la enviaremos a tu correo.
          </div>

        
       
        <!--begin::Action-->
         <button
            ref="kt_login_signin_submit"
            class="btn btn-primary align-self-center"
          >
            Cambiar Clave
          </button>
        </div>
        <p class="mt-3 mb-3 text-muted text-center">
          <a
            href="#"
            v-on:click="$router.push('login')"
            class="text-dark-60 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
           Volver
          </a>
        </p>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { GET_RECOVERY, UPDATE_PASSWORD } from "@/core/services/store/client.module";

export default {
  name: "recoveryConfirm",
  data() {
    return {
      step2:false,
      client:{},
    };
  },
  mounted () {
    this.getClient();
  },
  methods: {
    getClient() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_RECOVERY, this.$route.params.token)
          .then((response)=>{this.client = response, this.$Progress.finish()});
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      const token = this.$route.params.token;
      setTimeout(() => {
        this.$store
          .dispatch(UPDATE_PASSWORD, token)
          .then(() => this.step2=true);
      }, 500);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.client.errors
    })
  }
};
</script>
<style scoped>
.messaging {font-size: 0.8em;}
.alert-success {
    color: #155724 !important;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
</style>